<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content-center">
  <mat-radio-group class="radio-group" aria-label="Select an option"
                   [(ngModel)]="selectedReportType"
                   (change)="onReportSelectionChange()">
    <mat-radio-button *ngFor="let reportType of getReportTypes()" [value]="reportType">
      {{reportType}}
    </mat-radio-button>
  </mat-radio-group>
  
  <br>
  
  <ng-container *ngIf="isNotBankFileOrPaymentSummary">
    <mat-form-field class="w-90">
      <mat-label>Payee</mat-label>
      <mat-select [formControl]="payeeFormControl">
        <mat-option
          *ngFor="let payee of selectedReportType == reportType.ProviderRemittanceAdvice ? payment.providerPayees : payment.beneficiaryPayees"
          [value]="payee">
          {{payee.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button [mat-dialog-close]="false" color="warn">Close</button>
  <button class="dialog-button" mat-raised-button color="primary" (click)="onGenerateClick()"
          [disabled]="disableGenerateButton()">
    Generate
    <mat-icon *ngIf="disableGenerateButton()" class="info-icon" matTooltip="There is no payee selected">
      help_outline
    </mat-icon>
  </button>
</mat-dialog-actions>
